import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Stipend Disbursement Status")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-5 pb-0" }
const _hoisted_4 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_5 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "ALL Summary")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Quarterly Summary")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Bank Summary")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Association Summary")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 4 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Mobile Banking Summary")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 5 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "card-title mt-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Agent Banking Summary")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_34 = { class: "collapse show" }
const _hoisted_35 = { class: "card-body p-0" }
const _hoisted_36 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_37 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_40 = { class: "table-responsive mt-3" }
const _hoisted_41 = { class: "table table-borderless gy-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_43 = { style: {} }
const _hoisted_44 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_45 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_46 = {
  key: 1,
  class: ""
}
const _hoisted_47 = { class: "" }
const _hoisted_48 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_49 = { class: "table-responsive mt-3" }
const _hoisted_50 = { class: "table table-borderless gy-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Quarterly "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_52 = { style: {} }
const _hoisted_53 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_54 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_55 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_56 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_57 = { class: "" }
const _hoisted_58 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_59 = { class: "table table-borderless gy-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","width":"40%"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_61 = { style: {} }
const _hoisted_62 = {
  class: "align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_63 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_64 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_65 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_66 = { class: "" }
const _hoisted_67 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_68 = { class: "table table-borderless gy-4" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","width":"40%"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_70 = { style: {} }
const _hoisted_71 = {
  class: "align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_72 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_73 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_74 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_75 = { class: "" }
const _hoisted_76 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_77 = { class: "table-responsive mt-3" }
const _hoisted_78 = { class: "table table-borderless gy-4" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_80 = { style: {} }
const _hoisted_81 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_82 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_83 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_84 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_85 = { class: "" }
const _hoisted_86 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_87 = { class: "table-responsive mt-3" }
const _hoisted_88 = { class: "table table-borderless gy-4" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","width":"40%"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Selected "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Disbursed ")
  ])
], -1)
const _hoisted_90 = { style: {} }
const _hoisted_91 = {
  class: "align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_92 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_93 = {
  class: "text-center align-middle",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_94 = { class: "card mt-5 mb-5 mb-xl-10" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_migration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Stipend Disbursement Report")
  ])
], -1)
const _hoisted_96 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_97 = { class: "collapse show" }
const _hoisted_98 = { class: "card-body border-top p-4" }
const _hoisted_99 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-md-2" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = { class: "col-md-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_107 = { class: "col-md-2" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Date", -1)
const _hoisted_109 = { class: "col-md-2" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "End Date", -1)
const _hoisted_111 = { class: "col-md-2 mt-4" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "card mt-5 mb-5 mb-xl-10" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_migration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Stipend Disbursed Trainee Count ")
  ])
], -1)
const _hoisted_116 = { class: "card-body pb-0" }
const _hoisted_117 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_118 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_119 = { class: "nav-item" }
const _hoisted_120 = { class: "nav-item" }
const _hoisted_121 = { class: "nav-item" }
const _hoisted_122 = { class: "nav-item" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "card mb-5 mb-xl-10 mt-2" }
const _hoisted_125 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_126 = { class: "collapse show" }
const _hoisted_127 = { class: "card-body border-top p-6" }
const _hoisted_128 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_129 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_130 = { class: "" }
const _hoisted_131 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_132 = { class: "table table-borderless gy-4" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Bank Account & 80% Attendance "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Ethnic (A) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Disabled (B) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Female of Poor District (C) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Poor (D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Total (A+B+C+D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Actions ")
  ])
], -1)
const _hoisted_134 = { style: {} }
const _hoisted_135 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_136 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_137 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_138 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_139 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_140 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_141 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_142 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_143 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center"}
}
const _hoisted_144 = ["href"]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_148 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_149 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_150 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_151 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_152 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_153 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_154 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_155 = ["href"]
const _hoisted_156 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_159 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_160 = { class: "table table-borderless gy-4" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Bank Account & 80% Attendance "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Ethnic (A) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Disabled (B) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Female of Poor District (C) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Poor (D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Total (A+B+C+D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Actions ")
  ])
], -1)
const _hoisted_162 = { style: {} }
const _hoisted_163 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_164 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_165 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_166 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_167 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_168 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_169 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_170 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_171 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center"}
}
const _hoisted_172 = ["href"]
const _hoisted_173 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_174 = [
  _hoisted_173
]
const _hoisted_175 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_176 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_177 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_178 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_179 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_180 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_181 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_182 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_183 = ["href"]
const _hoisted_184 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_185 = [
  _hoisted_184
]
const _hoisted_186 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_187 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_188 = { class: "table table-borderless gy-4" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Bank Account & 80% Attendance "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Ethnic (A) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Disabled (B) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Female of Poor District (C) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Poor (D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Total (A+B+C+D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Actions ")
  ])
], -1)
const _hoisted_190 = { style: {} }
const _hoisted_191 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_192 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_193 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_194 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_195 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_196 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_197 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_198 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_199 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center"}
}
const _hoisted_200 = ["href"]
const _hoisted_201 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_202 = [
  _hoisted_201
]
const _hoisted_203 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_204 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_205 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_206 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_207 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_208 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_209 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_210 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_211 = ["href"]
const _hoisted_212 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_213 = [
  _hoisted_212
]
const _hoisted_214 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_215 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_216 = { class: "table table-borderless gy-4" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Bank Account & 80% Attendance "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Ethnic (A) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Disabled (B) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Female of Poor District (C) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Poor (D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Total (A+B+C+D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Actions ")
  ])
], -1)
const _hoisted_218 = { style: {} }
const _hoisted_219 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_220 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_221 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_222 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_223 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_224 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_225 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_226 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_227 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center"}
}
const _hoisted_228 = ["href"]
const _hoisted_229 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_230 = [
  _hoisted_229
]
const _hoisted_231 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_232 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_233 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_234 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_235 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_236 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_237 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_238 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_239 = ["href"]
const _hoisted_240 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_241 = [
  _hoisted_240
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "0",
                  href: "#all",
                  role: "tab"
                }, " All ", 2)
              ]),
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 1 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "1",
                  href: "#quarterly",
                  role: "tab"
                }, " Quarterly ", 2)
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 2 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "2",
                  href: "#association",
                  role: "tab"
                }, " Association ", 2)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 3 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "3",
                  href: "#bank",
                  role: "tab"
                }, " Bank ", 2)
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 4 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "4",
                  href: "#mobile_banking",
                  role: "tab"
                }, " Mobile Banking ", 2)
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 5 }]),
                  "data-bs-toggle": "tab",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setActiveTab($event))),
                  "data-tab-index": "5",
                  href: "#agent_banking",
                  role: "tab"
                }, " Agent Banking ", 2)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.tabIndex === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
            : _createCommentVNode("", true),
          (_ctx.tabIndex === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (_ctx.tabIndex === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true),
          (_ctx.tabIndex === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            : _createCommentVNode("", true),
          (_ctx.tabIndex === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
            : _createCommentVNode("", true),
          (_ctx.tabIndex === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    (_ctx.tabIndex === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 0 }]),
                                id: "#all"
                              }, [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("table", _hoisted_41, [
                                    _hoisted_42,
                                    _createElementVNode("tbody", _hoisted_43, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.alltableData.selected), 1),
                                        _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.alltableData.disbursed), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tabIndex === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 1 }]),
                                id: "#quarterly"
                              }, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("table", _hoisted_50, [
                                    _hoisted_51,
                                    _createElementVNode("tbody", _hoisted_52, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quarterlyData, (info, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", _hoisted_53, _toDisplayString(info?.start_date
                                        ? _ctx.moment(info?.start_date).format(
                                            'DD-MM-YYYY'
                                          )
                                        : info?.start_date) + " to " + _toDisplayString(info?.end_date
                                        ? _ctx.moment(info?.end_date).format(
                                            'DD-MM-YYYY'
                                          )
                                        : info?.end_date), 1),
                                          _createElementVNode("td", _hoisted_54, _toDisplayString(info?.selected), 1),
                                          _createElementVNode("td", _hoisted_55, _toDisplayString(info?.disbursed), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ], 2)
                            ])
                          ])), [
                            [_directive_loading, _ctx.quarterlyLoading]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tabIndex === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 3 }]),
                                id: "#bank"
                              }, [
                                _createElementVNode("table", _hoisted_59, [
                                  _hoisted_60,
                                  _createElementVNode("tbody", _hoisted_61, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alltableData.bank, (info, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", _hoisted_62, _toDisplayString(info?.bank_name), 1),
                                        _createElementVNode("td", _hoisted_63, _toDisplayString(info?.selected), 1),
                                        _createElementVNode("td", _hoisted_64, _toDisplayString(info?.disbursed), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ], 2)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.tabIndex === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 2 }]),
                              id: "#association"
                            }, [
                              _createElementVNode("table", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("tbody", _hoisted_70, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alltableData.entity, (info, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", _hoisted_71, " [" + _toDisplayString(info?.entity_short_name) + "]-" + _toDisplayString(info?.entity_name), 1),
                                      _createElementVNode("td", _hoisted_72, _toDisplayString(info?.selected), 1),
                                      _createElementVNode("td", _hoisted_73, _toDisplayString(info?.disbursed), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ], 2)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.tabIndex === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 4 }]),
                            id: "#mobile_banking"
                          }, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("table", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("tbody", _hoisted_80, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alltableData.mobile_bank, (info, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", _hoisted_81, _toDisplayString(info?.name), 1),
                                      _createElementVNode("td", _hoisted_82, _toDisplayString(info?.selected), 1),
                                      _createElementVNode("td", _hoisted_83, _toDisplayString(info?.disbursed), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tabIndex === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 5 }]),
                            id: "#agent_banking"
                          }, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("table", _hoisted_88, [
                                _hoisted_89,
                                _createElementVNode("tbody", _hoisted_90, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alltableData.agent_bank, (info, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", _hoisted_91, _toDisplayString(info?.bank_name), 1),
                                      _createElementVNode("td", _hoisted_92, _toDisplayString(info?.selected), 1),
                                      _createElementVNode("td", _hoisted_93, _toDisplayString(info?.disbursed), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])), [
            [_directive_loading, _ctx.summaryLoading]
          ])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      _createElementVNode("div", _hoisted_94, [
        _hoisted_95,
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    _hoisted_102,
                    _hoisted_103,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.tranche) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _hoisted_105,
                    _hoisted_106,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      name: "entity_id",
                      multiple: "",
                      "collapse-tags": "",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _hoisted_108,
                    _createVNode(_component_el_form_item, { prop: "start_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.start_date,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          style: {"width":"100%"},
                          type: "date",
                          name: "start_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _createVNode(_component_el_form_item, { prop: "end_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.end_date,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          style: {"width":"100%"},
                          type: "date",
                          name: "end_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getData())),
                      type: "button",
                      class: "btn btn-success mt-4",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_112
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.showCourseNotice == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
            _createElementVNode("div", _hoisted_114, [
              _hoisted_115,
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("ul", _hoisted_118, [
                    _createElementVNode("li", _hoisted_119, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", { active: _ctx.tabnextIndex === 1 }]),
                        "data-bs-toggle": "tab",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setActivenextTab($event))),
                        "data-tab-index": "1",
                        href: "#training_partner",
                        role: "tab"
                      }, " Training Partner ", 2)
                    ]),
                    _createElementVNode("li", _hoisted_120, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", { active: _ctx.tabnextIndex === 2 }]),
                        "data-bs-toggle": "tab",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setActivenextTab($event))),
                        "data-tab-index": "2",
                        href: "#bank_disbursed",
                        role: "tab"
                      }, " Bank ", 2)
                    ]),
                    _createElementVNode("li", _hoisted_121, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", { active: _ctx.tabnextIndex === 3 }]),
                        "data-bs-toggle": "tab",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setActivenextTab($event))),
                        "data-tab-index": "3",
                        href: "#mobile_banking_disbursed",
                        role: "tab"
                      }, " Mobile Banking ", 2)
                    ]),
                    _createElementVNode("li", _hoisted_122, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link", { active: _ctx.tabnextIndex === 4 }]),
                        "data-bs-toggle": "tab",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setActivenextTab($event))),
                        "data-tab-index": "4",
                        href: "#agent_banking_disbursed",
                        role: "tab"
                      }, " Agent Banking ", 2)
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.showCourseNotice == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            (_ctx.tabnextIndex === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                  _createElementVNode("div", _hoisted_130, [
                                    _createElementVNode("div", _hoisted_131, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["tab-pane", { active: _ctx.tabnextIndex === 1 }]),
                                        id: "#training_partner"
                                      }, [
                                        _createElementVNode("table", _hoisted_132, [
                                          _hoisted_133,
                                          _createElementVNode("tbody", _hoisted_134, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.entityReportData, (data, key) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                                _createElementVNode("td", _hoisted_135, _toDisplayString(key + 1), 1),
                                                _createElementVNode("td", _hoisted_136, _toDisplayString(data?.entity_name), 1),
                                                _createElementVNode("td", _hoisted_137, _toDisplayString(data?.bank), 1),
                                                _createElementVNode("td", _hoisted_138, _toDisplayString(data?.ethnic), 1),
                                                _createElementVNode("td", _hoisted_139, _toDisplayString(data?.disabled), 1),
                                                _createElementVNode("td", _hoisted_140, _toDisplayString(data?.female), 1),
                                                _createElementVNode("td", _hoisted_141, _toDisplayString(data?.poor), 1),
                                                _createElementVNode("td", _hoisted_142, _toDisplayString(data?.ethnic +
                                      data?.disabled +
                                      data?.female +
                                      data?.poor), 1),
                                                (
                                      data?.ethnic +
                                        data?.disabled +
                                        data?.female +
                                        data?.poor >
                                      0
                                    )
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_143, [
                                                      _createElementVNode("a", {
                                                        target: "_blank",
                                                        href: 
                                        `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                        data?.id +
                                        '&tranche_id=' +
                                        this.batch.tranche +
                                        '&start_date=' +
                                        this.batch.start_date +
                                        '&end_date=' +
                                        this.batch.end_date +
                                        '&account_type=' +
                                        'entitycall'
                                      ,
                                                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                        "data-search-type": "course",
                                                        "data-search-key": "",
                                                        title: "Stipend Disbursed"
                                                      }, _hoisted_146, 8, _hoisted_144)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", null, [
                                              _hoisted_147,
                                              _createElementVNode("td", _hoisted_148, _toDisplayString(this.total_bank_account_entity), 1),
                                              _createElementVNode("td", _hoisted_149, _toDisplayString(this.total_ethnic_entity), 1),
                                              _createElementVNode("td", _hoisted_150, _toDisplayString(this.total_disable_entity), 1),
                                              _createElementVNode("td", _hoisted_151, _toDisplayString(this.total_female_entity), 1),
                                              _createElementVNode("td", _hoisted_152, _toDisplayString(this.total_poor_entity), 1),
                                              _createElementVNode("td", _hoisted_153, _toDisplayString(this.total_ethnic_entity +
                                    this.total_disable_entity +
                                    this.total_female_entity +
                                    this.total_poor_entity), 1),
                                              (
                                    this.total_ethnic_entity +
                                      this.total_disable_entity +
                                      this.total_female_entity +
                                      this.total_poor_entity >
                                    0
                                  )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_154, [
                                                    _createElementVNode("a", {
                                                      target: "_blank",
                                                      href: 
                                      `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                      this.batch.entity_id +
                                      '&tranche_id=' +
                                      this.batch.tranche +
                                      '&start_date=' +
                                      this.batch.start_date +
                                      '&end_date=' +
                                      this.batch.end_date +
                                      '&account_type=' +
                                      'entitycall'
                                    ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Training Course"
                                                    }, _hoisted_157, 8, _hoisted_155)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ])
                                      ], 2)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.tabnextIndex === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                  _createElementVNode("div", _hoisted_159, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tab-pane", { active: _ctx.tabnextIndex === 2 }]),
                                      id: "#bank_disbursed"
                                    }, [
                                      _createElementVNode("table", _hoisted_160, [
                                        _hoisted_161,
                                        _createElementVNode("tbody", _hoisted_162, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bankReportData, (data, key) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                              _createElementVNode("td", _hoisted_163, _toDisplayString(key + 1), 1),
                                              _createElementVNode("td", _hoisted_164, _toDisplayString(data?.bank_name), 1),
                                              _createElementVNode("td", _hoisted_165, _toDisplayString(data?.bank), 1),
                                              _createElementVNode("td", _hoisted_166, _toDisplayString(data?.ethnic), 1),
                                              _createElementVNode("td", _hoisted_167, _toDisplayString(data?.disabled), 1),
                                              _createElementVNode("td", _hoisted_168, _toDisplayString(data?.female), 1),
                                              _createElementVNode("td", _hoisted_169, _toDisplayString(data?.poor), 1),
                                              _createElementVNode("td", _hoisted_170, _toDisplayString(data?.ethnic +
                                    data?.disabled +
                                    data?.female +
                                    data?.poor), 1),
                                              (
                                    data?.ethnic +
                                      data?.disabled +
                                      data?.female +
                                      data?.poor >
                                    0
                                  )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_171, [
                                                    _createElementVNode("a", {
                                                      target: "_blank",
                                                      href: 
                                      `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                      this.batch.entity_id +
                                      '&tranche_id=' +
                                      this.batch.tranche +
                                      '&start_date=' +
                                      this.batch.start_date +
                                      '&end_date=' +
                                      this.batch.end_date +
                                      '&account_type=' +
                                      'bank' +
                                      '&bank_id=' +
                                      data?.id
                                    ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Stipend Disbursed"
                                                    }, _hoisted_174, 8, _hoisted_172)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("tr", null, [
                                            _hoisted_175,
                                            _createElementVNode("td", _hoisted_176, _toDisplayString(this.total_bank_account_bank), 1),
                                            _createElementVNode("td", _hoisted_177, _toDisplayString(this.total_ethnic_bank), 1),
                                            _createElementVNode("td", _hoisted_178, _toDisplayString(this.total_disable_bank), 1),
                                            _createElementVNode("td", _hoisted_179, _toDisplayString(this.total_female_bank), 1),
                                            _createElementVNode("td", _hoisted_180, _toDisplayString(this.total_poor_bank), 1),
                                            _createElementVNode("td", _hoisted_181, _toDisplayString(this.total_ethnic_bank +
                                  this.total_disable_bank +
                                  this.total_female_bank +
                                  this.total_poor_bank), 1),
                                            (
                                  this.total_ethnic_bank +
                                    this.total_disable_bank +
                                    this.total_female_bank +
                                    this.total_poor_bank >
                                  0
                                )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_182, [
                                                  _createElementVNode("a", {
                                                    target: "_blank",
                                                    href: 
                                    `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                    this.batch.entity_id +
                                    '&tranche_id=' +
                                    this.batch.tranche +
                                    '&start_date=' +
                                    this.batch.start_date +
                                    '&end_date=' +
                                    this.batch.end_date +
                                    '&account_type=' +
                                    'bank' +
                                    '&bank_id=' +
                                    -1
                                  ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_185, 8, _hoisted_183)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ], 2)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.tabnextIndex === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                  _createElementVNode("div", _hoisted_187, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tab-pane", { active: _ctx.tabnextIndex === 3 }]),
                                      id: "#mobile_banking_disbursed"
                                    }, [
                                      _createElementVNode("table", _hoisted_188, [
                                        _hoisted_189,
                                        _createElementVNode("tbody", _hoisted_190, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.mobilebankReportData, (data, key) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                              _createElementVNode("td", _hoisted_191, _toDisplayString(key + 1), 1),
                                              _createElementVNode("td", _hoisted_192, _toDisplayString(data?.name), 1),
                                              _createElementVNode("td", _hoisted_193, _toDisplayString(data?.bank), 1),
                                              _createElementVNode("td", _hoisted_194, _toDisplayString(data?.ethnic), 1),
                                              _createElementVNode("td", _hoisted_195, _toDisplayString(data?.disabled), 1),
                                              _createElementVNode("td", _hoisted_196, _toDisplayString(data?.female), 1),
                                              _createElementVNode("td", _hoisted_197, _toDisplayString(data?.poor), 1),
                                              _createElementVNode("td", _hoisted_198, _toDisplayString(data?.ethnic +
                                    data?.disabled +
                                    data?.female +
                                    data?.poor), 1),
                                              (
                                    data?.ethnic +
                                      data?.disabled +
                                      data?.female +
                                      data?.poor >
                                    0
                                  )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_199, [
                                                    _createElementVNode("a", {
                                                      target: "_blank",
                                                      href: 
                                      `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                      this.batch.entity_id +
                                      '&tranche_id=' +
                                      this.batch.tranche +
                                      '&start_date=' +
                                      this.batch.start_date +
                                      '&end_date=' +
                                      this.batch.end_date +
                                      '&mobile_bank_id=' +
                                      data?.id +
                                      '&account_type=' +
                                      'mobile'
                                    ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Stipend Disbursed"
                                                    }, _hoisted_202, 8, _hoisted_200)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("tr", null, [
                                            _hoisted_203,
                                            _createElementVNode("td", _hoisted_204, _toDisplayString(this.total_bank_account_mobile), 1),
                                            _createElementVNode("td", _hoisted_205, _toDisplayString(this.total_ethnic_mobile), 1),
                                            _createElementVNode("td", _hoisted_206, _toDisplayString(this.total_disable_mobile), 1),
                                            _createElementVNode("td", _hoisted_207, _toDisplayString(this.total_female_mobile), 1),
                                            _createElementVNode("td", _hoisted_208, _toDisplayString(this.total_poor_mobile), 1),
                                            _createElementVNode("td", _hoisted_209, _toDisplayString(this.total_ethnic_mobile +
                                  this.total_disable_mobile +
                                  this.total_female_mobile +
                                  this.total_poor_mobile), 1),
                                            (
                                  this.total_ethnic_mobile +
                                    this.total_disable_mobile +
                                    this.total_female_mobile +
                                    this.total_poor_mobile >
                                  0
                                )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_210, [
                                                  _createElementVNode("a", {
                                                    target: "_blank",
                                                    href: 
                                    `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                    this.batch.entity_id +
                                    '&tranche_id=' +
                                    this.batch.tranche +
                                    '&start_date=' +
                                    this.batch.start_date +
                                    '&end_date=' +
                                    this.batch.end_date +
                                    '&account_type=' +
                                    'mobile' +
                                    '&mobile_bank_id=' +
                                    -1
                                  ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_213, 8, _hoisted_211)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ], 2)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.tabnextIndex === 4)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                  _createElementVNode("div", _hoisted_215, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tab-pane", { active: _ctx.tabnextIndex === 4 }]),
                                      id: "#agent_banking_disbursed"
                                    }, [
                                      _createElementVNode("table", _hoisted_216, [
                                        _hoisted_217,
                                        _createElementVNode("tbody", _hoisted_218, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.agentbankReportData, (data, key) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                              _createElementVNode("td", _hoisted_219, _toDisplayString(key + 1), 1),
                                              _createElementVNode("td", _hoisted_220, _toDisplayString(data?.bank_name), 1),
                                              _createElementVNode("td", _hoisted_221, _toDisplayString(data?.bank), 1),
                                              _createElementVNode("td", _hoisted_222, _toDisplayString(data?.ethnic), 1),
                                              _createElementVNode("td", _hoisted_223, _toDisplayString(data?.disabled), 1),
                                              _createElementVNode("td", _hoisted_224, _toDisplayString(data?.female), 1),
                                              _createElementVNode("td", _hoisted_225, _toDisplayString(data?.poor), 1),
                                              _createElementVNode("td", _hoisted_226, _toDisplayString(data?.ethnic +
                                    data?.disabled +
                                    data?.female +
                                    data?.poor), 1),
                                              (
                                    data?.ethnic +
                                      data?.disabled +
                                      data?.female +
                                      data?.poor >
                                    0
                                  )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_227, [
                                                    _createElementVNode("a", {
                                                      target: "_blank",
                                                      href: 
                                      `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                      this.batch.entity_id +
                                      '&tranche_id=' +
                                      this.batch.tranche +
                                      '&start_date=' +
                                      this.batch.start_date +
                                      '&end_date=' +
                                      this.batch.end_date +
                                      '&account_type=' +
                                      'agent' +
                                      '&agent_bank__id=' +
                                      data?.id
                                    ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Stipend Disbursed"
                                                    }, _hoisted_230, 8, _hoisted_228)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128)),
                                          _createElementVNode("tr", null, [
                                            _hoisted_231,
                                            _createElementVNode("td", _hoisted_232, _toDisplayString(this.total_bank_account_agent), 1),
                                            _createElementVNode("td", _hoisted_233, _toDisplayString(this.total_ethnic_agent), 1),
                                            _createElementVNode("td", _hoisted_234, _toDisplayString(this.total_disable_agent), 1),
                                            _createElementVNode("td", _hoisted_235, _toDisplayString(this.total_female_agent), 1),
                                            _createElementVNode("td", _hoisted_236, _toDisplayString(this.total_poor_agent), 1),
                                            _createElementVNode("td", _hoisted_237, _toDisplayString(this.total_ethnic_agent +
                                  this.total_disable_agent +
                                  this.total_female_agent +
                                  this.total_poor_agent), 1),
                                            (
                                  this.total_ethnic_agent +
                                    this.total_disable_agent +
                                    this.total_female_agent +
                                    this.total_poor_agent >
                                  0
                                )
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_238, [
                                                  _createElementVNode("a", {
                                                    target: "_blank",
                                                    href: 
                                    `${this.VUE_APP_TMS}/stipend/stipend-disbursed-trainee-view?entity_id=` +
                                    this.batch.entity_id +
                                    '&tranche_id=' +
                                    this.batch.tranche +
                                    '&start_date=' +
                                    this.batch.start_date +
                                    '&end_date=' +
                                    this.batch.end_date +
                                    '&account_type=' +
                                    'agent' +
                                    '&agent_bank__id=' +
                                    -1
                                  ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_241, 8, _hoisted_239)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ], 2)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.reportLoading]
    ])
  ], 64))
}